import React from 'react'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import { grey } from '@material-ui/core/colors';

function StoryTextAsset(props) {
  const { asset } = props

  return (
    <CardContent>
      <Typography
          variant="body1"
          component="p"
          style={{ color: grey[900] }}
          dangerouslySetInnerHTML={{ __html: asset.cleanText }} />
    </CardContent>
  )
}

export default StoryTextAsset
